/**
 * Panel Groups
 */

// Vendors
import $ from 'jquery';

// Event listener on panel-collapse show
$('body').on('show.bs.collapse', '.panel', event => {
  $(event.currentTarget).addClass('is-open');
});

// Event listener on panel-collapse hidden
$('body').on('hide.bs.collapse', '.panel', event => {
  $(event.currentTarget).removeClass('is-open');
});



// WEBPACK FOOTER //
// ./assets/js/components/panel-groups.js